import { Controller, useForm } from 'react-hook-form';
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { Label } from "../../../components/Label/Label";
import PageTitle from '../../../components/PageTitle/PageTitle';
import HelperService from '../../../utility/HelperService';
import { useEffect, useRef, useState } from 'react';
import routePaths from '../../../Navigation/routePaths';
import { createOrUpdateProjectInterface, ProjectInterface, ProjectState } from '../ProjectTypes';
import { permissionsInterface, reduxInitialState } from '../../onBoarding/onBoardingTypes';
import { projectCreateRequest } from '../ProjectAction';
import Grid, { GridColumn, GridHeader, GridRow } from '../../../components/Grid/Grid';
import { Pencil, Plus, Trash } from 'react-bootstrap-icons';
import AddScheduleModal from '../../../components/AddScheduleModal';
import { toast } from 'react-toastify';
import { NAVIGATION_REQUEST } from '../../../redux/action_constant';
import UploadFile from '../../../components/UploadFile/UploadFile';
import WebService from '../../../utility/WebService';
import { IoClose } from 'react-icons/io5';
import DocIcon from "../../../assets/images/doc-icon.svg";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { FaDownload, FaUpload } from 'react-icons/fa';

interface propData {
    onSubmit: (params: createOrUpdateProjectInterface) => Promise<{ message: string, uuid: string }>;
};

const headers: GridHeader[] = [
    {
        title: "Name",
        class: 'text-left',
    },
    {
        title: "Percentage",
        class: 'text-left',
    },
    {
        title: "Amount",
        class: 'text-left',
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: 'text-center',
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const projectTypeOptions = [
    { value: "COMMERCIAL_PLOT", label: "Commercial Plot" },
    { value: "RESIDENTIAL_PLOT", label: "Residential Plot" },
    { value: "COMMERCIAL_SHOP", label: "Commercial Shop" },
    { value: "COMMERCIAL_MALL", label: "Commercial Mall" },
    { value: "ROW_HOUSE", label: "Row House" }
];


const CreateProject = (props: propData) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const projectData: ProjectState = useSelector((state: reduxInitialState) => state.ProjectReducer);
    const { handleSubmit, formState: { errors, isValid }, control, watch, register, reset, setValue } = useForm<ProjectInterface>({});
    const watchAllFields = watch();
    const [rows, setRows] = useState<GridRow[]>([]);
    const rowCompute = useRef<GridRow[]>([]);
    const sheduleList = useRef<any[]>([{ id: new Date().getTime(), name: "Advance", percentage: "0", amount: "0" }]);
    const [sheduleEdit, setSheduleEdit] = useState<any>({});
    const [isShow, setIsShow] = useState<boolean>(false);
    const [fileData, setFileData] = useState<any>(null);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
        }
    }, [token])

    useEffect(() => {
        if (permissions) {
            if (window.location.pathname === routePaths.UPDATE_PROJECT.path && projectData && projectData.editProject && !HelperService.isEmptyObject(projectData.editProject)) {
                setIsEdit(true);
                reset(projectData.editProject);
                setFileData(projectData.editProject.project_images && projectData.editProject.project_images.length && projectData.editProject.project_images[0] || null);
                sheduleList.current = projectData.editProject.payment_schedules ? projectData.editProject.payment_schedules : [];
            } else if (window.location.pathname === routePaths.ADD_NEW_PROJECT.path) {
                reset({});
                setIsEdit(false);
                setFileData(null);

            } else {
                dispatch(({ type: NAVIGATION_REQUEST, payload: routePaths.PROJECTPAGE.path }));
            }

            getFormatedProjectRow(sheduleList.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissions]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    const onSubmit = async (data: ProjectInterface) => {
        if (sheduleList.current.length == 0) { toast.error("Please add schedule"); return; };
        let pecentage = 0;
        let isNotName = false;
        sheduleList.current.forEach((item) => {
            pecentage += Number(item.percentage);
            if (!item.name) {
                isNotName = true;
                return;
            }
        });
        if (isNotName) { toast.error("Please enter schedule name"); return; };
        if (pecentage > 100) {
            toast.error("Percentage should not be greater than 100");
            return;
        };
        data.payment_schedule = sheduleList.current;
        !data.project_unit && (data.project_unit = 0);
        const response = await props.onSubmit({ data: data, isEdit: isEdit, file: (!isEdit && fileData) ? fileData.file : null });
        console.log("response", response);

    };

    const onClickAddSchedule = () => {
        setSheduleEdit({});
        setIsShow(true);
    };

    const onCloseAddShedule = (data: any) => {
        setIsShow(false);
        if (data) {
            let list = [...sheduleList.current];
            if (data.id) {
                let index = list.findIndex((item) => item.id === data.id);
                list[index] = data;
            } else {
                list.push({ id: new Date().getTime(), name: data.name, percentage: data.percentage, amount: data.amount });
            }
            sheduleList.current = [...list];
            getFormatedProjectRow(list);
        }
        setSheduleEdit({});
    };

    const getFormatedProjectRow = (list: any[]) => {
        let rows: GridRow[] = [];
        for (var i in list) {
            let columns: GridColumn[] = [];
            columns.push({ value: list[i].name ? list[i].name : "N/A" });
            columns.push({ value: list[i].percentage ? list[i].percentage : "0" });
            columns.push({ value: list[i].amount ? list[i].amount : "0" });
            columns.push({ value: ViewDetail(Number(i)) });
            rows.push({ data: columns });
        }
        rowCompute.current = rows;
        setRows([...rowCompute.current]);
    };

    const ViewDetail = (i: number) => {
        return (
            <span className="action-btns">
                <button type='button' className="cursor-pointer  btn-edit btn" onClick={() => onEditShedule(i)}> <Pencil /> </button>
                <button type='button' className="cursor-pointer btn btn-delete" onClick={() => onDeleteShedule(i)}> <Trash /> </button>
            </span >
        );
    };

    const onEditShedule = (i: number) => {
        setSheduleEdit(sheduleList.current[i]);
        setIsShow(true);
    };

    const onDeleteShedule = (i: number) => {
        let list = [...sheduleList.current];
        list = list.filter((item, index) => index !== i);
        sheduleList.current = list;
        getFormatedProjectRow(list);
    };

    const onUploadFile = (data: any, name: string, size: string, length: number, width: number) => {
        const blob = URL.createObjectURL(data);
        var isImageExte = /(\.(jpg|jpeg|png))$/i;
        var isVideo = /(\.(mp4))$/i;
        var isPdf = /(\.(pdf))$/i;
        let type = "";

        if (isImageExte.test(name)) {
            type = "IMAGE";
        } else if (isVideo.test(name)) {
            type = "VIDEO";
        } else if (isPdf.test(name)) {
            type = "PDF";
        }
        uploadFile({ type: type, file: data, file_name: name, file_size: size, length: length, width: width });
    };

    const uploadFile = (data: any) => {
        WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data.file, body: { type: "PROJECT" }, id: "project_create_update_btn" })
            .then(async (res: any) => {
                setValue("file_name", res.file_name);
                setValue("file_size", data.file_size);
                setValue("length", data.length);
                setValue("width", data.width);
                if (isEdit) {
                    WebService.postAPI({ action: `upload/project/image`, body: { uuid: watchAllFields.uuid, file_name: res.file_name, length: data.length, width: data.width, size: data.file_size }, id: "project_create_update_btn" })
                        .then(async (resp: any) => {
                            toast.success("File uploaded successfully");
                            setFileData({ ...data, uuid: resp.uuid, file: null, file_name: res.file_name });
                        }).catch(async (error: any) => { });
                } else {
                    toast.success("File uploaded successfully");
                    setFileData({ ...data, file_name: res.file_name });
                }
            })
            .catch(async (error: any) => { });
    };

    const onDeleteImage = () => {
        if (fileData.file) {
            setFileData(null);
        } else {
            WebService.deleteAPI({ action: `delete/project/image/${fileData?.uuid}`, id: "project_create_update_btn" })
                .then((res: any) => {
                    toast.success("Image deleted successfully");
                    setFileData(null);
                })
                .catch((e: any) => { });
        }
    };

    const uploadXlsxFile = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('project_id', watchAllFields.uuid);
        WebService.fileUploadAPI({ action: 'upload/project-units/file', file: file, body: { project_id: watchAllFields.uuid }, key: 'file' })
            .then((response: any) => {
                toast.success(response.message || "File uploaded successfully");
            }).catch((error: any) => { toast.error(error.message || "Failed to upload file"); });
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        // Check for ctrl+alt+o+p
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
            setShowHiddenFields(true);
        }

        // Remove the key from the set
        setPressedKeys((prev: any) => {
            const updated = new Set(prev);
            updated.delete(key);
            return updated;
        });
    };

    const onExportUnits = () => {
        WebService.getAPI({ action: `export/project-units/${watchAllFields.uuid}`, responseType: 'arraybuffer' })
            .then((response: any) => {
                // in response getting buffer data and convert that data into blob and download that file with file name project_uuid_units.xlsx  
                const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `project_${watchAllFields.uuid}_units.xlsx`);
                document.body.appendChild(link);
                link.click();
            }).catch((error: any) => { toast.error(error.message || "Failed to export file"); });
    };

    const getSignedUrl = (fileName: string) => {
        WebService.postAPI({ action: "get/signed-url", body: { key: `projects/${fileName}` } })
            .then((res: any) => {
                if (res && res.signed_url) {
                    window.open(res.signed_url, "_blank");
                } else {
                    toast.error("Failed to get signed URL");
                }
            })
            .catch((error: any) => { toast.error("Failed to get signed URL"); });
    };

    return (
        <div className="app-page">
            <div className="d-flex justify-content-between align-items-center ">
                <PageTitle title={window.location.pathname === routePaths.UPDATE_PROJECT.path ? "Edit Project" : "Add New Project"} backArrow={true} active={showHiddenFields} />
                {isEdit && <div>
                    <Button className='me-2' variant="secondary" onClick={() => onExportUnits()}>Export Units <FaDownload /> </Button>

                    {/* Button to upload xlxs file for project units */}
                    <Button variant="primary" onClick={() => document.getElementById('fileInput')?.click()}>Import Units <FaUpload /> </Button>
                    <input type="file" id="fileInput" style={{ display: 'none' }} accept=".xlsx, .xls" onChange={(e) => {
                        const file = e.target.files ? e.target.files[0] : null;
                        if (file) {
                            uploadXlsxFile(file);
                        }
                    }} />
                </div>}
            </div>

            {permissions && (permissions.can_update || permissions.can_write) && <Card style={{ height: '100%' }}>
                <Card.Body>
                    <form className=" form-style" onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col lg={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Project Name</Form.Label>
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input
                                            type="text"
                                            className="form-control ps-3 p-2"
                                            placeholder="Project Name"
                                            {...register("project_name", { required: true })}
                                        />
                                    </div>
                                    {errors.project_name && (
                                        <div className="login-error mb-3">
                                            <Label title={watchAllFields.project_name ? "Min. 2 and Max. 30 charecetrs" : "Please enter project name"} modeError={true} />
                                        </div>
                                    )}
                                </Form.Group>

                                <Controller
                                    control={control}
                                    name="address"
                                    rules={{
                                        required: true,
                                    }}
                                    render={({
                                        field
                                    }) => (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1 mt-1">
                                                <textarea rows={4} className="form-control ps-3 p-2" placeholder="Address" value={watch().address} {...register("address", { required: true })} />
                                            </div>
                                            {
                                                errors.address &&
                                                <div className="login-error mb-3">
                                                    <Label
                                                        title={"Please enter address"}
                                                        modeError={true}
                                                    />
                                                </div>
                                            }
                                        </Form.Group>
                                    )}
                                />

                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Guideline rate</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="Guideline rate"
                                                    {...register("guideline_rate", { required: true, min: 1 })}
                                                    onKeyPress={HelperService.allowOnlyNumericValue}
                                                />
                                            </div>
                                            {errors.guideline_rate && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Enter Guideline rate"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Controller
                                            control={control}
                                            name="project_type"
                                            rules={{
                                                required: true,
                                            }}
                                            render={({ field: { onChange } }) => (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Project Type</Form.Label>
                                                    <span className="text-danger">*</span>
                                                    <Select
                                                        options={projectTypeOptions}
                                                        onChange={(e: any) => {
                                                            onChange(e.value);
                                                        }}
                                                        value={projectTypeOptions.find(
                                                            (_: any) => _.value == watchAllFields.project_type
                                                        )}
                                                    />
                                                    {errors.project_type && (
                                                        <div className="login-error mb-3">
                                                            <Label title={"Please select payment type"} modeError={true} />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            )}
                                        />
                                    </Col>
                                    <Col lg={showHiddenFields ? 6 : 12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>No of units</Form.Label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control ps-3 p-2"
                                                    placeholder="No of units"
                                                    {...register("project_unit", { required: true, min: window.location.pathname !== routePaths.UPDATE_PROJECT.path ? Number(watchAllFields.sold_unit) : 1 })}
                                                    onKeyPress={HelperService.allowOnlyNumericValue}
                                                    disabled={isEdit}
                                                />
                                            </div>
                                            {errors.project_unit && (
                                                <div className="login-error mb-3">
                                                    <Label title={"Enter No. of units"} modeError={true} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    {
                                        showHiddenFields && <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Land Purchase Price</Form.Label>
                                                <span className="text-danger">*</span>
                                                <div className="input-group mb-1">
                                                    <input
                                                        type="text"
                                                        className="form-control ps-3 p-2"
                                                        placeholder="Land Purchase Price"
                                                        {...register("land_purchase_price", { required: true, min: 0 })}
                                                        onKeyPress={HelperService.allowOnlyNumericValue}
                                                    />
                                                </div>
                                                {errors.land_purchase_price && (
                                                    <div className="login-error mb-3">
                                                        <Label title={"Enter Land Purchase Price"} modeError={true} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    }
                                    {
                                        showHiddenFields && <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Current Market Value</Form.Label>
                                                <div className="input-group mb-1">
                                                    <input
                                                        type="text"
                                                        className="form-control ps-3 p-2"
                                                        placeholder="Current Market Value"
                                                        {...register("current_market_value", { required: false, min: 0 })}
                                                        onKeyPress={HelperService.allowOnlyNumericValue}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    }
                                    {
                                        showHiddenFields && <Col lg={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Land Area (In acres)</Form.Label>
                                                <span className="text-danger">*</span>
                                                <div className="input-group mb-1">
                                                    <input
                                                        type="text"
                                                        className="form-control ps-3 p-2"
                                                        placeholder="Land Area (In acres)"
                                                        {...register("land_area", { required: true, min: window.location.pathname !== routePaths.UPDATE_PROJECT.path ? Number(watchAllFields.sold_unit) : 1 })}
                                                        onKeyPress={HelperService.allowOnlyNumericValue}
                                                    />
                                                </div>
                                                {errors.land_area && (
                                                    <div className="login-error mb-3">
                                                        <Label title={"Enter Land Area"} modeError={true} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    }
                                </Row>

                                {!fileData && <UploadFile
                                    key={new Date().getTime()}
                                    onChange={(data: any, name: string, size: string, length: number, width: number) => { onUploadFile(data, name, size, length, width); }}
                                    acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                                    message="Upload or Drag and Drop project image"
                                    acceptedSize={5}
                                />}

                                {fileData &&
                                    <Card className={`border p-2 d-inline-block px-3 mb-3 me-2`}>
                                        <div className="d-flex gap-3 align-items-center">
                                            <div className="me-1">
                                                <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                                            </div>
                                            <div><img src={DocIcon} width={40} height={40} alt="" /></div>
                                            <div>
                                                <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(fileData ? fileData.file_name : watchAllFields.file_name)}>{fileData.file_name}</p>
                                                <span className="text-secondary">{fileData.file_size}KB</span>
                                            </div>
                                        </div>
                                    </Card>
                                }
                            </Col>

                            <Col lg={6}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className='mb-0 font-18 font-medium'>Payment Schedule (Template)</p>
                                    <Button className="btn btn-brand-1" onClick={() => { onClickAddSchedule() }}> <Plus size={20} className="ms-1" /> Add</Button>
                                </div>
                                <Grid rows={rows} headers={headers} />
                            </Col>

                            <>
                                <Col lg={3}></Col>
                                <Col lg={3} className="text-center mt-3">
                                    <Button className="btn-brand-1 me-3 w-100" disabled={!isValid} type="submit" id="project_create_update_btn">
                                        {window.location.pathname === routePaths.UPDATE_PROJECT.path ? (watchAllFields.project_type == "COMMERCIAL_SHOP" || watchAllFields.project_type == "COMMERCIAL_MALL" || watchAllFields.project_type == "ROW_HOUSE") ? "Update & Next" : "Update" : (watchAllFields.project_type == "COMMERCIAL_SHOP" || watchAllFields.project_type == "COMMERCIAL_MALL" || watchAllFields.project_type == "ROW_HOUSE") ? "Save & Next" : 'Save'}
                                    </Button>
                                </Col>
                                <Col lg={3} className="text-center mt-3">
                                    <Button className="bg-danger me-3 w-100 btn-outline-danger text-bg-dark" type="button" id="cancel_booking_btn" onClick={() => { navigate(routePaths.PROJECTPAGE.path) }}>
                                        Cancel
                                    </Button>
                                </Col>
                            </>

                        </Row>
                    </form>
                </Card.Body>
            </Card>}

            <AddScheduleModal data={sheduleEdit} isShow={isShow} isClose={(data: any) => { onCloseAddShedule(data) }} />
        </div>
    )
};

const mapDispatchToProps = (dispatch: any) => ({
    onSubmit: (params: createOrUpdateProjectInterface) => dispatch(projectCreateRequest(params)),
});

export default connect(null, mapDispatchToProps)(CreateProject);